import { css } from '@inter-ikea-kompis/web-component';
export default class SheetFooterStyle {
    /**
     * Returns styles.
     *
     * @param options Options Object.
     * @param options.theme Theme.
     * @returns Styles.
     */
    static getStyle(options) {
        const { spacing, color, breakpoint } = options.theme;
        return css `
			:host {
				display: flex;
				flex-shrink: 0;
				padding: ${spacing.space150 / 16}rem ${spacing.space150 / 16}rem;
				border-top: ${1 / 16}rem solid ${color.border.light};
			}
			.container {
				width: 100%;
				display: flex;
			}
			@media screen and (min-width: ${breakpoint.large.width / 16}rem) {
				:host {
					padding: ${spacing.space150 / 16}rem ${spacing.space300 / 16}rem;
				}
			}
		`;
    }
}
//# sourceMappingURL=SheetFooterStyle.js.map